import { render, staticRenderFns } from "./ViewerPageKonva.vue?vue&type=template&id=4b2b443a&scoped=true"
import script from "./ViewerPageKonva.vue?vue&type=script&lang=js"
export * from "./ViewerPageKonva.vue?vue&type=script&lang=js"
import style0 from "./ViewerPageKonva.vue?vue&type=style&index=0&id=4b2b443a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b443a",
  null
  
)

export default component.exports